import styled from "styled-components";

const ComparisonStyleWrapper = styled.div`
  margin-top: 55px;
  p {
    margin-bottom: 26px;
  }
  .widget_title {
    margin-bottom: 15px;
    font-size: 22px;
  }
`;

export default ComparisonStyleWrapper;
